import React from 'react';
import noFreightIcon from '../../../../../assets/svg/profile.svg';

const NoFreights = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img
        src={noFreightIcon}
        alt="هیچ رکوردی یافت نشد."
        height={60}
        width={60}
      />
      <div>هیچ رکوردی یافت نشد.</div>
    </div>
  );
};

export default React.memo(NoFreights);
